/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProgramsQueries } from '../../models/get-programs-queries';
import { GetProgramsQueriesResult } from '../../models/get-programs-queries-result';

export interface ApiProgramGetProgramsPost$Plain$Params {
  
    /**
     * portfolioId
     */
    body?: GetProgramsQueries
}

export function apiProgramGetProgramsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProgramGetProgramsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProgramsQueriesResult>> {
  const rb = new RequestBuilder(rootUrl, apiProgramGetProgramsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProgramsQueriesResult>;
    })
  );
}

apiProgramGetProgramsPost$Plain.PATH = '/api/Program/GetPrograms';
